/**
 * @module Template-Home-Page-Style-2
 */

import { useEffect, useState } from "react";
import { loadScript } from "../../../globals/common-functions";
import { TypeLandingPage, TypePageHome2 } from "../../@types/pageTypes";
import { getHomeLanding } from "../../../api/home-landing";
import SectionHome2Slider from "../../sections/home/home2/home2-slider";
import SectionHome2About from "../../sections/home/home2/home2-about";
import SectionHome2CaseStudy from "../../sections/home/home2/home2-case-study";
import SectionHome2Services from "../../sections/home/home2/home2-services";
import SectionHome2Testimonials from "../../sections/home/home2/home2-testimonials";
import SectionHome2Team from "../../sections/home/home2/home2-team";
import SectionHome2Pricing from "../../sections/home/home2/home2-pricing";
import SectionHome1WhatWeDo from "../../sections/home/home1/home1-what-we-do";
import SectionHome1InstaGallery from "../../sections/home/home1/home1-insta-gallery";
import SectionHome1Blogs from "../../sections/home/home1/home1-blogs";
import SectionHome1Clients from "../../sections/home/home1/home1-clients";
import SectionContactForm2 from "../../sections/contact/contact-form2";
import SectionHome2FAQ from "../../sections/home/home2/home2-faq";
import SectionHome2WhatWeDo from "../../sections/home/home2/home2-what-we-do";
import { ToastContainer } from "react-toastify";

/**
 * 
 * @returns Markup template for sample page Home2
 */
const LandingPage = () => {

    const _home2Default: TypeLandingPage = {};
    const [results, setResults] = useState(_home2Default);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {

        getHomeLanding((response: TypeLandingPage) => {
            setIsFetching(false);
            setResults(response);
            loadScript("js/custom.js")
            loadScript("js/masonry-grid.js");
        })

    }, [isFetching])

    return (
        <><ToastContainer />
            {/*SLIDER BANNER START*/}
            {

                results.slider &&
                <section  id="home">
                <SectionHome2Slider
                    _slider={results.slider!} /></section>
            }

            {/*SLIDER BANNER END*/}

            {/* About US SECTION START */}
            {
                results.about &&
                <section id="about">
                <SectionHome2About
                    _about={results.about!}
                    _clients={results.clients} /></section>
            }
             
             {
                results.whatWeDo &&
                <SectionHome1WhatWeDo
                    _whatWeDo={results.whatWeDo}
                    />
            }
            
               {
                results.services &&
                <section id="services">
                <SectionHome2Services 
                _services={results.services!} /></section>
            }
       
              {
                results.about2 &&
                <SectionHome2About
                    _about={results.about2!}
                    _clients={results.clients} />
            }
    {
                results.faq &&
                <section id="whyus">
                <SectionHome2FAQ 
                _faqs={results.faq!} /> </section>
            
            }
            <section id="contactus">
            <SectionContactForm2 /></section>
            {/* Team SECTION END */}

            {/* FAQ SECTION START */}
            
            {/* OUR BLOG SECTION END */}
        </>
    )
}
export default LandingPage;